// Test IDs for the Glamping in Paradise landing page.

export const HOME = {
        // Header / nav
        headerLogo: 'header-logo',
        headerNavStays: 'header-nav-stays',
        headerNavGallery: 'header-nav-gallery',
        headerNavAbout: 'header-nav-about',
        headerNavContact: 'header-nav-contact',
        headerBookCta: 'header-book-cta',

        // Hero
        heroVideo: 'hero-video',
        heroTitle: 'hero-title',
        heroBookCta: 'hero-book-cta',
        heroExploreCta: 'hero-explore-cta',

        // Accommodations
        staysSection: 'stays-section',
        stayCardSmallDome: 'stay-card-small-dome',
        stayCardLargeDome: 'stay-card-large-dome',
        stayCardBus: 'stay-card-bus',
        stayBookSmallDome: 'stay-book-small-dome',
        stayBookLargeDome: 'stay-book-large-dome',
        stayNotifyBus: 'stay-notify-bus',
        busVideo: 'bus-video',

        // Gallery
        gallerySection: 'gallery-section',
        galleryItem: (i) => `gallery-item-${i}`,

        // About / amenities
        aboutSection: 'about-section',

        // Contact
        contactSection: 'contact-section',
        contactForm: 'contact-form',
        contactName: 'contact-name',
        contactEmail: 'contact-email',
        contactUnit: 'contact-unit',
        contactCheckIn: 'contact-check-in',
        contactCheckOut: 'contact-check-out',
        contactGuests: 'contact-guests',
        contactMessage: 'contact-message',
        contactSubmit: 'contact-submit',

        // Footer
        footer: 'site-footer',
        footerSocialInstagram: 'footer-social-instagram',
        footerSocialFacebook: 'footer-social-facebook',
        footerSocialTiktok: 'footer-social-tiktok',
};

// Legacy export used by the template — kept so existing imports still resolve.
HOME.emergentLink = 'home-emergent-link';
